var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('hypo-alert'),(_vm.loading)?_c('mds-loader'):_c('router-view',{staticClass:"view",class:_vm.viewClass})],1)}
var staticRenderFns = []

export { render, staticRenderFns }